export function parseDateOrUndefined(
  date: string | undefined | null
): Date | undefined {
  if (!date) return undefined
  return new Date(date)
}
